// ─── Fish types ────────────────────────────────────────────────────────────
/** Active fish types shown in the catch form (excludes legacy "ørret"). */
export const FISH_TYPES = [
    "laks",
    "brunørret",
    "sjøørret",
    "pukkellaks",
    "oppdrettslaks",
    "støing",
    "røye",
];
/** Active gear types shown in the catch form (excludes legacy "rapala"). */
export const GEAR_TYPES = [
    "flue",
    "wobbler",
    "spinner",
    "sluk",
    "mark_orm",
    "annet",
];
/** Fish types valid for bulk småfisk registration (all ørret subtypes). */
export const BULK_FISH_TYPES = ["brunørret", "sjøørret"];
export const SUPPORTED_LOCALES = [
    "nb",
    "en",
    "de",
    "pl",
    "sv",
    "fi",
    "is",
];
/** A hotel, restaurant etc. close to a river, curated by the river admin. */
/**
 * What a sponsor gets, lowest first: friend (name in "Støttet av"), local (+ logo),
 * supporter (+ labelled guide card with own text), partner (+ photo, first in the
 * list), main (+ logo at the top of the river page).
 */
export const SPONSOR_TIERS = ["friend", "local", "supporter", "partner", "main"];
/** 0 = not a sponsor, 1–5 = friend…main. `sponsor: true` without a tier counts as supporter. */
export function sponsorRank(p) {
    if (p.sponsorTier)
        return SPONSOR_TIERS.indexOf(p.sponsorTier) + 1;
    return p.sponsor ? 3 : 0;
}
//# sourceMappingURL=index.js.map